import Joi from 'joi';

/**
 * Schema for validating check-out record properties.
 * @description This schema ensures that the odometer value is correctly entered as a number
 * and that the check-out date is valid and not set in the future.
 * Additional properties beyond those defined in the schema are ignored.
 */
export const checkOutSchema = () =>
	Joi.object({
		odometerValue: Joi.number().allow(null).messages({
			'number.base': 'validations|check-out|odometer-value-must-be-number',
		}),
		checkOutAt: Joi.date().max('now').required().messages({
			'date.base': 'validations|check-out|check-out-at-date-must-be-valid',
			'date.max': 'validations|check-out|check-out-at-date-cannot-be-in-future',
			'any.required': 'validations|check-out|check-out-at-date-required',
		}),
	})
		// Allows additional properties to be included in the object without causing validation errors
		.unknown(true);
